import { Button, ButtonWithLoader, Row, Wizard } from '@valid-eval/shared-react-components';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Loading from 'components/Loading';
import { useFetchPhases, useUpdatePhase } from 'data/features/phasesHooks';

import { EventStepComponentProps } from '.';
import EditEventStepForm from './components/EditEventStepForm';
import PhasesItem, { PhasesItemRef } from './components/PhasesItem';

function PhasesStepComponent({ event, label, subLabel, nextStep }: EventStepComponentProps) {
  const { t } = useTranslation();
  const { phases, isLoading } = useFetchPhases(event?.id);
  const phaseItemsRefs = useRef<PhasesItemRef[]>([]);
  const { saving } = useUpdatePhase();

  const handleSaveProgress = async () => {
    try {
      await Promise.all(phaseItemsRefs.current.map((ref) => ref?.save()));
      return true;
    } catch {
      return false;
    }
  };

  const handleNextStep = async () => {
    await handleSaveProgress();
    nextStep();
  };

  return (
    <EditEventStepForm label={label} subLabel={subLabel}>
      <Row className="mt-3">
        {phases?.map((phase, index) => (
          <PhasesItem
            key={phase.id}
            phase={phase}
            event={event}
            ref={(el: PhasesItemRef | null) => {
              el && (phaseItemsRefs.current[index] = el);
            }}
          />
        ))}
        {isLoading && <Loading />}
      </Row>
      <Wizard.Footer>
        <div className="d-flex justify-content-end align-items-center">
          <Button
            variant="secondary"
            type="button"
            className="me-3"
            onClick={handleSaveProgress}
            disabled={saving}
          >
            {t('event.form.save_progress')}
          </Button>
          <ButtonWithLoader variant="primary" loading={saving} onClick={handleNextStep}>
            {t('event.form.next')}
          </ButtonWithLoader>
        </div>
      </Wizard.Footer>
    </EditEventStepForm>
  );
}

export default PhasesStepComponent;
